import {FormItemBase} from './form-item-base';

export class FormItemToggleSwitch extends FormItemBase<string> {
  controlType = 'toggleSwitch';
}
